export type OrganizationLaunchpadProfileDetails = {
  question: string;
  answer: string;
  index: number;
  other?: string;
};

export enum OrganizationLaunchpadProfileStatus {
  pending = "pending",
  completed = "completed",
}
